/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  DirectoryAttributeOption,
  DirectoryAttributeOption$inboundSchema,
} from "./directoryattributeoption.js";
import {
  DirectoryGroupOption,
  DirectoryGroupOption$inboundSchema,
} from "./directorygroupoption.js";
import {
  DirectoryRoleMapping,
  DirectoryRoleMapping$inboundSchema,
} from "./directoryrolemapping.js";

export type ListDirectoryRoleMappingsResult = {
  /**
   * Distinct attribute values set on active directory users.
   */
  attributes: Array<DirectoryAttributeOption>;
  /**
   * Active directory groups in the organization.
   */
  groups: Array<DirectoryGroupOption>;
  /**
   * Live directory role mappings.
   */
  mappings: Array<DirectoryRoleMapping>;
};

/** @internal */
export const ListDirectoryRoleMappingsResult$inboundSchema: z.ZodMiniType<
  ListDirectoryRoleMappingsResult,
  unknown
> = z.object({
  attributes: z.array(DirectoryAttributeOption$inboundSchema),
  groups: z.array(DirectoryGroupOption$inboundSchema),
  mappings: z.array(DirectoryRoleMapping$inboundSchema),
});

export function listDirectoryRoleMappingsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListDirectoryRoleMappingsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListDirectoryRoleMappingsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListDirectoryRoleMappingsResult' from JSON`,
  );
}
